import { render, staticRenderFns } from "./bbsItem.vue?vue&type=template&id=08d5b168&scoped=true"
import script from "./bbsItem.vue?vue&type=script&lang=js"
export * from "./bbsItem.vue?vue&type=script&lang=js"
import style0 from "./bbsItem.vue?vue&type=style&index=0&id=08d5b168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5b168",
  null
  
)

export default component.exports